import React from "react";
import "./Parser.css";
import axios from "axios";
import { JsonView, allExpanded, defaultStyles } from "react-json-view-lite";
import "react-json-view-lite/dist/index.css";
import Navbar from "./Navbar";
import Title from "./Title";

function Parser() {
  const REACT_APP_CENTRAL_API_URL =
    process.env.REACT_APP_CENTRAL_API_URL || "http://localhost:3000/api/parser";
  const parserApiUrl = REACT_APP_CENTRAL_API_URL + "/parse-not-emit";

  const [error, setError] = React.useState<string>("");
  const [isError, setIsError] = React.useState<boolean>(false);
  const [result, setResult] = React.useState<string>("");
  const [processing, setProcessing] = React.useState<boolean>(false);
  const [timer, setTimer] = React.useState<number>(0);

  const inputRef = React.useRef<HTMLInputElement>(null);
  const timerRef = React.useRef<NodeJS.Timeout | null>(null);

  // Function to start the timer
  const startTimer = () => {
    setTimer(0);
    timerRef.current = setInterval(() => {
      setTimer((prev) => prev + 1);
    }, 1000);
  };

  // Function to stop the timer
  const stopTimer = () => {
    if (timerRef.current) {
      clearInterval(timerRef.current);
      timerRef.current = null;
    }
  };

  // Cleanup timer on component unmount
  React.useEffect(() => {
    return () => {
      stopTimer();
    };
  }, []);

  const onParserClick = () => {
    const input = inputRef.current?.value;
    if (input) {
      setResult("");
      setProcessing(true);
      setIsError(false);
      setError("");

      // Start timer after request is sent
      startTimer();

      axios
        .post(parserApiUrl, {
          url: input,
          action: "parseFromUI",
        })
        .then((res) => {
          setError("");
          setResult(res.data);
          setIsError(false);
          setProcessing(false);
          stopTimer();
        })
        .catch((err) => {
          setResult("");
          setError(err.response.data);
          setIsError(true);
          setProcessing(false);
          stopTimer();
        });
    }
  };

  // Create arrow function that returns result of the parser or error
  const getParsedData = (): string => {
    if (result) {
      return result;
    }
    if (error) {
      return error;
    }
    return "";
  };

  // Format timer display
  const formatTimer = (seconds: number): string => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins.toString().padStart(2, "0")}:${secs
      .toString()
      .padStart(2, "0")}`;
  };

  return (
    <div className="parser">
      <Title title="Parser" />
      <div className="parser__input">
        <button className="parser__btnSend" onClick={onParserClick}>
          Senden
        </button>
        <input type="text" className="parser__urlInput" ref={inputRef} />
      </div>
      <div className="parser__result">
        {/* Display the result of the parser */}
        {getParsedData() && (
          <JsonView
            data={getParsedData()}
            shouldExpandNode={allExpanded}
            style={defaultStyles}
          />
        )}
        {isError && <div className="parser__error"></div>}
        {processing && (
          <div className="parser__timer">
            <span className="parser__timer-text">Verarbeitung läuft: </span>
            <span className="parser__timer-count">{formatTimer(timer)}</span>
          </div>
        )}
      </div>
      <Navbar />
    </div>
  );
}

export default Parser;
